<div>
  <OnboardingIndex
    title="First Time Login"
    submitButtonText="Submit"
    :verification_running="action_running"
    @submit="first_time_login"
  >
    <template v-slot:form-content>
      <div v-if="organization_name || user_email" class="mb-3">
        <div v-if="organization_name" class="mb-3">
          <label class="text-xs">Organization</label>
          <input
            type="text"
            class="form-control form-control-lg text-xs bg-light py-2 border-0"
            :value="organization_name"
            readonly
          />
        </div>
        <div class="row">
          <div class="col-md-6 mb-3">
            <label class="text-xs">Admin Name</label>
            <input
              type="text"
              class="form-control form-control-lg text-xs bg-light py-2 border-0"
              :value="[user_first_name, user_last_name].filter(Boolean).join(' ')"
              readonly
            />
          </div>
          <div class="col-md-6 mb-3">
            <label class="text-xs">Admin Email</label>
            <input
              type="email"
              class="form-control form-control-lg text-xs bg-light py-2 border-0"
              :value="user_email"
              readonly
            />
          </div>
        </div>
      </div>

      <div v-if="show_name_inputs === true">
        <div class="row">
          <div class="col-md-6 mb-3">
            <!-- First Name Field -->
            <div class="position-relative">
              <label for="first-name" class="text-xs">First Name</label>
              <input
                class="form-control form-control-lg text-xs bg-light py-2 pe-4 border-0"
                v-model="user_first_name"
                id="first-name"
                placeholder="Enter your first name"
                required
              />
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <!-- Last Name Field -->
            <div class="position-relative">
              <label for="last-name" class="text-xs">Last Name</label>
              <input
                class="form-control form-control-lg text-xs bg-light py-2 pe-4 border-0"
                v-model="user_last_name"
                id="last-name"
                placeholder="Enter your last name"
                required
              />
            </div>
          </div>
        </div>
      </div>

      <h6 class="text-dark text-xs">
        Create a password to secure your account.
      </h6>
      <!-- New Password Field -->
      <div class="mb-3 position-relative">
        <label for="password" class="text-xs">New Password</label>
        <input
          :type="show_password ? 'text' : 'password'"
          class="form-control password form-control-lg text-xs bg-light py-2 pe-5 border-0"
          v-model="new_password"
          id="password"
          placeholder="Enter your password"
          required
        />
        <i
          :class="show_password ? 'bi bi-eye' : 'bi bi-eye-slash'"
          class="position-absolute end-0 top-50 translate-middle-y-eye me-3 text-secondary cursor-pointer z-2"
          @click="toggle_password_visibility"
        ></i>
      </div>

      <!-- Confirm Password Field -->
      <div class="mb-3 position-relative">
        <label class="text-xs">Confirm password</label>
        <input
          :type="show_confirm_password ? 'text' : 'password'"
          class="form-control password form-control-lg text-xs bg-light py-2 pe-5 border-0"
          v-model="confirm_password"
          id="confirm_password"
          placeholder="Confirm your password"
          required
        />
        <i
          :class="show_confirm_password ? 'bi bi-eye' : 'bi bi-eye-slash'"
          class="position-absolute end-0 top-50 translate-middle-y-eye me-3 text-secondary cursor-pointer z-2"
          @click="toggle_confirm_password_visibility"
        ></i>
      </div>

      <!-- Phone Number Field -->
       <div class="mb-3">
        <label class="text-xs">Phone Number</label>
        <input
          type="text"
          class="form-control form-control-lg text-xs bg-light py-2 border-0"
          v-model="phone_number"
          maxlength="10"
          @keypress="validate_numbers"
          oninput="this.value = this.value.replace(/\D/g, '')"
          id="phone_number"
          placeholder="Enter phone number"
          required
        />  
        <small
            v-if="phone_number && !validate_phone_number(phone_number)"
            class="text-danger p-2 text-xs fw-bold d-block"
          >
            Please enter a valid 10-digit phone number
          </small>
          <small
            v-else
            class="text-danger p-2 text-xs fw-bold d-none"
          >
          Please enter a valid phone number
          </small>
      </div>
    </template>
  </OnboardingIndex>
</div>
